
import { repository } from 'jtech'

export const ServiceRequestListRepository = {

  nmInterfaceServiceRequest: 'serviceRequest.pesquisar',

  loadDatatable: async function () {
    const dada = await repository.resolveDatatable(this.nmInterfaceServiceRequest)
    return dada
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceServiceRequest, { ...params })
  }
}
